import { $enum } from 'ts-enum-util'
import { GetFacilitiesAnalyticsQueryParams as FacilitiesQueryParams } from 'apps/tms/types/apiTypes'
import { ANALYTICS_COVERAGE_TYPES } from 'apps/tms/types/draftShipments'
import {
  EQUIPMENT_TYPES,
  EQUIPMENT_INTERMODAL_TYPES,
  MODE_TYPES,
  MODE_INTERMODAL_TYPES,
} from 'apps/tms/types/shipments'
import { IShipmentsUsers } from 'apps/tms/types/users'

const toObject = (label: string, value: string) => ({ value, label })

export const EQUIPMENT_OPTIONS = $enum(EQUIPMENT_TYPES).map(toObject)

export const EQUIPMENT_OPTIONS_INTERMODAL = $enum({
  ...EQUIPMENT_TYPES,
  ...EQUIPMENT_INTERMODAL_TYPES,
}).map(toObject)

export const MODE_OPTIONS = $enum(MODE_TYPES).map(toObject)
export const MODE_OPTIONS_INTERMODAL = $enum({ ...MODE_TYPES, ...MODE_INTERMODAL_TYPES }).map(
  toObject
)

export const COVERAGE_TYPE_OPTIONS = $enum(ANALYTICS_COVERAGE_TYPES).map(toObject)

export enum DateFilterOptions {
  'last_week' = 'Last Week',
  'yesterday' = 'Yesterday',
  'today' = 'Today',
  'tomorrow' = 'Tomorrow',
  'this_week' = 'This Week',
  'next_week' = 'Next Week',
}
export const DATE_FILTER_OPTIONS = $enum(DateFilterOptions).map(toObject)

export enum DateRangeOptions {
  '7_days' = 'Past Week',
  '30_days' = 'Past Month',
  '3_months' = 'Past 3 Months',
  '6_months' = 'Past 6 Months',
  '12_months' = 'Past Year',
  'month_to_date' = 'Month to Date',
  'year_to_date' = 'Year to Date',
}
export const DATE_RANGE_OPTIONS = $enum(DateRangeOptions).map(toObject)
export const DATE_RANGE_OPTIONS_MAP = DATE_RANGE_OPTIONS.reduce((dictionary, { label, value }) => {
  return { ...dictionary, [value]: label }
}, {} as Record<FacilitiesQueryParams['dateFilter'], string>)

export enum DateRangeOptionsShort {
  '7_days' = '7D',
  '30_days' = '30D',
  '3_months' = '3M',
  '6_months' = '6M',
  '12_months' = '12M',
  'month_to_date' = 'MTD',
  'year_to_date' = 'YTD',
}
export const DATE_RANGE_OPTIONS_SHORT = $enum(DateRangeOptionsShort).map(toObject)

export const EMPTY_USERS: IShipmentsUsers[] = []

export const SHIPMENT_LIST_FILTERS_LOCAL_STORAGE_KEY = 'tmsShipmentListFilters'
export const HOME_FILTERS_LOCAL_STORAGE_KEY = 'tmsHomeFilters'

export type TPricingType = 'variable' | 'fixed'
export type TShipmentType = 'ltl' | 'ftl' | 'intermodal'
